import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./About.module.css";
import { IMAGES } from "../../../data/images";
import { Animate, Parallax } from "../../animations";

const About = () => {
  return (
    <section className={styles.about}>
      <div className={styles.aboutInner}>
        <Animate variant="slideRight" className={styles.aboutLeft}>
          <h4 id="heading-small">About Us</h4>
          <h1 id="heading-large">India's Trusted Study Abroad Partner</h1>
          <p>
            Since 2018, Ever Sky Overseas has helped over 5,000 Indian students
            secure admissions at top universities across the USA, Canada, UK,
            Australia, and Europe. Our team of experienced counsellors, visa
            specialists, and writers work together to make your study-abroad
            journey seamless.
          </p>
          <p>
            We believe every deserving student deserves access to global education.
            That's why we offer transparent pricing, scholarship guidance, and
            personalized support from your first consultation to your first day on
            campus abroad.
          </p>
          <NavLink to="/about">
            <button className={styles.aboutButton}>Learn More</button>
          </NavLink>
        </Animate>
        <Animate variant="slideLeft" delay={150} className={styles.aboutRight}>
          <Parallax speed={0.15}>
            <img
              src={IMAGES.aboutUsSection}
              alt="Ever Sky Overseas team"
              className={styles.aboutImage}
            />
          </Parallax>
        </Animate>
      </div>
    </section>
  );
};

export default About;
